/**
 * @author Ariel
 * @description 岗位分类管理页面配置
 * @Date 2019/12/31
 */
import React from "react";
let componentName = 'positionCategory';

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    name: 'delFlag',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '岗位分类名称',
    name: 'name',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 20,
      placeholder: '岗位名称最多输入20个字',
      rules: [
        {
          required: true,
          message: '请输入岗位分类名称'
        },
        {
          pattern: /^[^\s]*$/,
          message: '岗位分类名称录入信息不能包含空格'
        }
      ]
    }
  },
  {
    title: '岗位分类编码',
    name: 'code',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 50,
      placeholder: '仅支持数字、字母、-、_',
      rules: [
        {
          required: true,
          message: '请输入岗位分类编码'
        },
        {
          pattern: /^[A-Za-z0-9-_]+$/,
          message: '岗位分类编码仅支持数字、字母、-、_'
        }
      ]
    }
  },
  {
    title: '描述',
    name: 'description',
    tableItem: {
      width: 350
    },
    formItem: {
      maxlength: 100,
      placeholder: '描述最多输入100个字',
      type: 'textarea'
    }
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps:{
        buttonSort: ['add','delete'],
        collapse: false
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['update'],
      rowOperateView: [],
      rowOperateProps: {
        width: 80,
        fixed: 'right',
      },
      commonOperate: {
        add: true,
        delete: true,
        edit: true
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
